<div class="footer-background"  [ngStyle]="{'background-image': 'url('+ StorageURL + data?.footer?.bg_image +')'}">
    <app-footer-one [data]="data" [logo]="logo"></app-footer-one>
</div>